import SvgSprite from '@Web/Src/Components/SvgSprite';
import LinkSection from '@Web/Src/UI/LinkSection';
import PropTypes from 'prop-types';
import { cn } from '@Shared/Helpers/Utilities';

function SectionHeader({
    type = 'dark',
    icon = '',
    title = '',
    desc = '',
    className = '',
    position = 'center',
    smallDescFont = false,
    link = '',
    linkText = '',
    handleClick,
    collectionName = 'section-icons-sprite',
    iconSize = '!size-12',
    additionalItem,
    topTitle = false,
}) {
    return (
        <div
            className={`${className} flex max-w-[770px] flex-col ${position === 'center' ? 'items-center gap-6' : 'large:items-center items-start gap-2'} justify-center`}
        >
            {icon && (
                <SvgSprite
                    className={cn(iconSize, type === 'dark' ? 'text-blue' : 'text-light')}
                    iconId={icon}
                    collectionName={collectionName}
                />
            )}
            {title &&
                (topTitle ? (
                    <h1
                        className={`small:text-2xl text-3xl font-bold ${position === 'center' ? 'text-center' : 'large:text-center text-left'} ${type === 'dark' ? '!text-dark' : 'text-light'}`}
                    >
                        {title}
                    </h1>
                ) : (
                    <h2
                        className={`small:text-2xl text-3xl font-bold ${position === 'center' ? 'text-center' : 'large:text-center text-left'} ${type === 'dark' ? '!text-dark' : 'text-light'}`}
                    >
                        {title}
                    </h2>
                ))}
            {desc && (
                <div
                    className={` ${smallDescFont ? 'text-base' : 'large:text-lg small:!text-sm text-xl'} ${position === 'center' ? 'text-center' : 'large:text-center text-left'} ${type === 'dark' ? '!text-dark' : 'text-light'}`}
                >
                    {desc}
                </div>
            )}
            {additionalItem && (
                <div
                    className={` ${smallDescFont ? 'text-base' : 'large:text-lg small:!text-sm text-xl'} ${position === 'center' ? 'text-center' : 'large:text-center text-left'} ${type === 'dark' ? '!text-dark' : 'text-light'}`}
                >
                    {additionalItem}
                </div>
            )}
            {link && (
                <LinkSection
                    className={'!mt-4'}
                    position={'left'}
                    handleClick={handleClick}
                    link={linkText}
                />
            )}
        </div>
    );
}

SectionHeader.propTypes = {
    type: PropTypes.oneOf(['dark', 'light']),
    icon: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default SectionHeader;
